<template>
  <div class="card">
    <div class="border-0 card-header">
      <div class="float-right" v-if="newOrder.length > 0">
        <span class="text-danger">Sort order changed.</span>
        <base-button type="neutral" class="ml-3 py-0 px-3" v-on:click="saveSortOrder">Save Sort Order</base-button>
        <base-button type="white" class="ml-1 py-0 px-3" v-on:click="resetSortOrder">Restore</base-button>
      </div>
      <h3 class="mb-0">Collection</h3>
    </div>
    <el-table-draggable handle=".handle" direction="vertical" v-on:drop="handleDrop">
      <el-table class="table-responsive table-flush"
                header-row-class-name="thead-light"
                :data="itemsCopy">
        <el-table-column label="Collection Item"
                         min-width="310px"
                         prop="name"
                         sortable>
          <template v-slot="{row}">
            <div class="media align-items-center">
              <i class="handle mr-3 fa fa-grip-vertical"></i>
              <a :href="'#/collection/collection-item/' + row.id + '/' + $route.params.id" class="avatar mr-3"
                 v-if="row.image">
                <img :src="row.image"/>
              </a>
              <div class="media-body">
                <a :href="'#/collection/collection-item/' + row.id + '/' + $route.params.id">
                  <span class="font-weight-600 name mb-0 text-sm">{{ row.title }}</span>
                </a>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column v-if="$route.params.id === 'job-postings'" label="Retailer"
                         min-width="310px"
                         prop="name"
                         sortable>
          <template v-slot="{row}">
            <div v-if="row.vendors">
              {{ row.vendors[0].title }}
            </div>
          </template>
        </el-table-column>

        <el-table-column v-if="$route.params.id === 'media-room'" label="Publisher"
                         min-width="200px"
                         prop="name"
                         sortable>
          <template v-slot="{row}">
            <div v-if="row.publishers">
              {{ row.publishers[0].title }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Publish Date" v-if="$route.params.id === 'media-room'" min-width="200px" sortable>
          <template v-slot="{row}">
            {{ row.publish | date }}
          </template>
        </el-table-column>


        <el-table-column min-width="180px">
          <template v-slot="{row}">
            <el-dropdown trigger="click" class="dropdown">
                    <span class="btn btn-sm btn-icon-only text-light">
                      <i class="fas fa-ellipsis-v mt-2"></i>
                    </span>
              <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                <a class="dropdown-item" :href="'#/collection/collection-item/'+row.id">Edit Collection Item</a>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </el-table-draggable>
    <div class="card-footer py-4 d-flex justify-content-end">
      <!--<base-pagination v-model="currentPage" :total="50"></base-pagination>-->
    </div>
  </div>
</template>
<script>
import {Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui'
import ElTableDraggable from 'element-ui-el-table-draggable'

export default {
  name: 'collections-table',
  props: {
    parent: [String, Boolean],
    items: [Array, Object],
    default: []
  },
  components: {
    ElTableDraggable,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      currentPage: 1,
      newOrder: [],
      itemsOriginal: JSON.parse(JSON.stringify(this.items)),
      itemsCopy: JSON.parse(JSON.stringify(this.items))
    };
  },
  methods: {
    handleDrop(drop) {
      this.newOrder = drop.list
    },
    saveSortOrder() {
      if (!this.parent)
        return false;

      const newOrder = JSON.parse(JSON.stringify(this.newOrder))
      const newSortOrderArray = []
      for (let i = 0; i < newOrder.length; i++) {
        let entity = newOrder[i]
        newSortOrderArray.push({
          id: entity.id,
          sequence: i + 1
        })
      }

      this.$store.dispatch('UPDATE_SORT_ORDER', {
        parent: this.parent,
        new_sort_order: newSortOrderArray
      })

      this.itemsOriginal = newOrder
      this.newOrder = []
    },
    resetSortOrder() {
      this.itemsCopy = JSON.parse(JSON.stringify(this.itemsOriginal))
      this.newOrder = []
    }
  }
}
</script>
<style lang="scss">
.vendor-link {
  display: block;
}

.handle {
  cursor: move;

  &:active {
    cursor: grab;
  }

  color: #BBBBBB;
  display: inline-block;
}

div.el-table .el-table__row:hover.sortable-chosen {
  background: #FFFFFF;
}

div.el-table .el-table__row.sortable-ghost {
  opacity: 0;
}
</style>
